import React from 'react';
import classes from "../FitnessPreview.module.scss";

const OptimallyMeIconSvg = () => {
    return (
        <svg className={classes.icon} width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="56" height="56" rx="28" fill="#F2F7FB" />
            <g clipPath="url(#clip0_5564_124643)">
                <path d="M39.9816 30.3143H35.2312C29.7924 30.3143 25.3633 25.8694 25.3633 20.4112V15.667H30.5726V20.4343C30.5726 23.0137 32.661 25.0864 35.2083 25.0864H39.9587V30.3143H39.9816Z" fill="#062021" />
                <path d="M29.2873 39.7336H26.6941V31.6499L24.055 29.0014H16V26.376H25.1336L29.2873 30.5675V39.7336Z" fill="#062021" />
            </g>
            <defs>
                <clipPath id="clip0_5564_124643">
                    <rect width="24" height="24.6667" fill="white" transform="translate(16 15.667)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default OptimallyMeIconSvg;